import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useLoginCheck = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/login") {
      const isLoggedIn = localStorage.getItem("token") != null;
      console.log("isLoggedIn is ", isLoggedIn);
      if (!isLoggedIn) {
        window.location.href = "/login";
      }
    }
  }, [location]);
};

export default useLoginCheck;
